import Icon from 'veui/components/Icon'

Icon.register({
  search: {
    paths: [
      {
        d: 'M39.76 36.93l7.65 7.66a2 2 0 01-2.82 2.82l-7.66-7.65a22.5 22.5 0 112.83-2.83zM22.5 41a18.5 18.5 0 100-37 18.5 18.5 0 000 37z'
      }
    ],
    width: '48',
    height: '48'
  }
})
